import { Component, Input, SimpleChanges } from '@angular/core';
import { StatusCode, newPriceRecommenderObjective } from '../core/enum';
import { Router } from '@angular/router';
import { UrlSecurityService } from '../shared/services/url-security.service';
import * as constant from '../shared/constants/constants';
import { UtilService } from '../shared/services/util.service';
import { TableVirtualScrollDataSource } from 'ng-table-virtual-scroll';
import { ScenerioService } from '../shared/services/scenerio.service';
import { StorageService } from '../shared/services/storage.service';
import { PriceRecommenderService } from '../shared/services/price-recommender.service';
import { forkJoin, map } from 'rxjs';

@Component({
  selector: 'app-result',
  templateUrl: './result.component.html',
  styleUrls: ['./result.component.scss']
})
export class ResultComponent  {
  
  /** Data Variables For Result */
  scenario_name_data: any = [];
  scenario_id_data: any = [];
  scenario_result_data: any = []

  /** Variable For Status */
  statusIndex : any;
  statusText : any = StatusCode

  /** variables for date */
  dateIndex: any;

  /** Pop Up Flag */
  objective_flag: boolean = false;

  /**Table viewport calculation */
  view_port_height: number = constant.common.defaultTableHeight;

  /**popup table variables */
  item_size: number = constant.common.itemSize;

  store_key : any = constant.scenario_comparison.stores;

  /** Table Variables */
  data_source = new TableVirtualScrollDataSource<any>();
  data_source2 = new TableVirtualScrollDataSource<any>();
  price_band_data_source:any = new TableVirtualScrollDataSource<any>([]);
  constraint_table_columns: any = [];
  item_details_table_columns: any = [];

  /** Objective enum variable */
  new_pr_objective: any = newPriceRecommenderObjective;
  
  @Input() result_data: any;
  @Input() result_config: any ={};

  configuration: any = {};

  constructor(private router : Router,private urlService: UrlSecurityService, public utilService : UtilService, private scenarioService : ScenerioService, private storageService: StorageService, private priceRecommenderService : PriceRecommenderService){}
  
  ngOnChanges(changes:SimpleChanges){
    if(changes['result_data'].currentValue){
      this.scenario_name_data = this.result_data.scenario_name_data;
      this.scenario_id_data = this.result_data.scenario_id_data;
      this.scenario_result_data = this.result_data.scenerio_data;
      this.constraint_table_columns = constant.price_recommender.constraint_pop_up_table_columns;
      this.item_details_table_columns = constant.price_recommender.item_details_pop_up_table_columns;
      this.getCofigValuesFromSession()
    }
  }  

    /** Get Config Values From Session Storage */
    async getCofigValuesFromSession() {
      this.configuration = await this.storageService.get(constant.storage_keys.configuration);
    }
  

  /** to check if there is Status Header */
  statusHeaderCheck(header:any, index:any){
    if(header.toLowerCase().includes('status')){
      this.statusIndex = index
    }
    if(header.toLowerCase().includes('date')){
      this.dateIndex = index
    }
    return header;
  }

  viewDetails(index:any){
    let scenario_id = this.scenario_id_data.header_data[index][0];
    this.router.navigate([constant.navigation.recommendationComparisonSku], { queryParams: { scenario_id: this.urlService.encryptUsingAES256(scenario_id)} })
  }

  /** Close Popup */
  closePopup() {
    this.objective_flag = false;
  }

  /**
   * calculation viewPort Height in px
   * @param count: length of data array
   */
  viewPortCalculation(count: number) {
    count = constant.common.zero ? this.view_port_height = count : this.view_port_height = this.utilService.viewPortCalcuation(count);
  }

  /** Open Objective popup */
  openObjectivePopUP(paylaod: any) {
    let sources = [
      this.scenarioService.getConstraintList(paylaod),
      this.priceRecommenderService.viewPriceBandConfig(paylaod)
    ]

    forkJoin(sources).pipe(map(([constraintDetails,priceBandDetails]:any)=>{
      return {
        constraintDetails: constraintDetails,
        priceBandDetails: priceBandDetails
      }
    })).subscribe({
      next:(next:any)=>{
        this.constraintDetails (next.constraintDetails);
        this.priceBandData(next.priceBandDetails);
        this.objective_flag = true;
      }
    })
  }

  /** Constraint Detail Handle */
  constraintDetails(data:any){
    this.data_source = new TableVirtualScrollDataSource(data["constraints"]);
    let item_details: any = [];
    data["item_details"].map((val: any) => {
      if(val.all_items == 1){
        item_details.push({
          product_category : val.skun02,
          items: 'All'
        })
      }
      else{
        val.sku01.map((val_items: any) => {
          item_details.push({
            product_category : val.skun02,
            items: val_items
          })
        })
      }
    });
    this.data_source2 = new TableVirtualScrollDataSource(item_details);
  }

  /** Price Band Details Handle */
  priceBandData(data:any){
    this.price_band_data_source = data ? new TableVirtualScrollDataSource(data) : new TableVirtualScrollDataSource([]);
  }

  /**get Constraints Payload */
  getConstraintsDTO(index: any) {
    let scenario_id = this.scenario_id_data.header_data[index][0];
    let payload: any = {
      "scenario_id": this.urlService.encrypt(scenario_id + '')
    }
    this.openObjectivePopUP(payload)
  }

    /** Price Metric Calculation With Two Decimal */
    priceMetricCalculationWithTwoDecimal(value: any) {
      return this.utilService.priceMetricCalculationWithDecimalService(value, this.configuration.decimal_points);
    }

}
